module.exports = __webpack_public_path__ + "static/media/Portraits Over Gchat Ch. 2.506df5d8.jpg";